<template>
  <div class="container" :style="iosOrAndroidStyle">
    <w-navbar
        v-show="iosOrAndroidShow"
        :icon="'iconchevron-left'"
        :cvShow="true"
        @mobileLeftBtn="leftBtnClick"
        :nav_title="isUpdate?'求职意向':''"
    />
    <w-loading v-if="loadingShow"/>
    <template v-else>
      <!-- <div v-if="!isUpdate">
        <div class="choose-title">想找什么样的工作</div>
        <div class="reminder">您可以在求职设置中修改您的求职偏好</div>
      </div> -->
      <!-- <template v-else> -->
        <p class="title top">当前状态</p>
        <div class="intentions" @click="handleClickUpdate">
          <span v-if="!is_student">职场人{{expect_status ? `-${expect_status}` : ''}}</span>
          <span v-else>学生党{{expect_work_type.length ? `-${(expect_work_type.join(","))}` : ''}}</span>
          <i class="iconfont iconchevron-right"></i>
        </div>
        <p class="title bottom">求职方向</p>
      <!-- </template> -->
      <div class="form">
        <div class="form-item">
          <div class="form-item-title">期望行业</div>
          <div class="form-item-result" @click="handleChooseIndustries">
            <div class="form-choose-title" v-if="!industriesConfirmData.length">请选择</div>
            <p class="form-choose-title" v-else style="color:#333;">
              <span>{{industriesConfirmData.map(item=>item.name).join(",")}}</span>
            </p>
            <span class="icon iconfont iconchevron-right"></span>
          </div>
        </div>
        <div class="form-item">
          <div class="form-item-title">职位类型</div>
          <div class="form-item-result" @click="moreState = true">
            <div class="form-choose-title" v-if="professionsConfirmData.length">
              <span class="checked-item">
                {{professionsConfirmData.map(item=>item.title).join(",")}}
              </span>
            </div>
            <div class="form-choose-title" v-else>请选择</div>
            <span class="icon iconfont iconchevron-right"></span>
          </div>
        </div>
        <div class="form-item">
          <div class="form-item-title">意向城市</div>
          <div class="form-item-result" @click="handleChooseCity">
            <div class="form-choose-title" v-if="!chooseCityList.length">请选择</div>
            <p class="form-choose-title" v-else>
            <span v-for="(item,index) in chooseCityList" :key="item.id" class="checked-item">
              {{item.city_name}}
              <span v-if="index!=chooseCityList.length-1">,</span>
            </span>
            </p>
            <span class="icon iconfont iconchevron-right"></span>
          </div>
        </div>
        <div class="form-item" v-if="!is_student">
          <div class="form-item-title">期望薪资</div>
          <div class="form-item-result" @click="handleChooseSalary">
            <div :class="expect_min_salary?'form-choose-title active':'form-choose-title'"
                 v-if=" (expect_max_salary  == null && expect_min_salary == null)||(expect_max_salary  == '' && expect_min_salary == '')">
              请选择
            </div>
            <div :class="expect_min_salary?'form-choose-title active':'form-choose-title'"
                 v-if=" (expect_max_salary == null||expect_max_salary=='') && (expect_min_salary != null&&expect_min_salary != '')"
            >{{expect_min_salary}}{{expect_min_salary == 100?'k以上':'k'}}
            </div>
            <div
                :class="expect_min_salary?'form-choose-title active':'form-choose-title'"
                v-if="expect_max_salary != null && expect_min_salary !=null&&expect_max_salary != '' && expect_min_salary !=''"
            >{{expect_min_salary+'k-'+expect_max_salary+'k'}}
            </div>
            <span class="icon iconfont iconchevron-right"></span>
          </div>
        </div>
      </div>

      <div class="next-box">
        <!-- professionsConfirmData.length>0&&industriesConfirmData.length>0 -->
        <div class="next" @click="saveEditInfo"
             :class="{'active':(chooseCityList.length>0)&&(is_student?true:(expect_min_salary&&expect_max_salary||expect_min_salary==100))}">
          {{ isNeedResume ? '下一步' : isUpdate ? '保存' : '去看职位' }}
        </div>
      </div>
    </template>
    <!-- 行业 -->
    <w-popup :state="industriesState" @handleClose="handleCancelIndustries">
      <div slot="content" class="content" @touchmove.prevent>
        <div class="top-btn">
          <div class="cancel-btn" @click="handleCancelIndustries">取消</div>
          <div class="confirm-btn" @click="handleConfirmIndustries">确定</div>
        </div>
        <div class="letter-wrapper-content">
          <cube-scroll class="choose-list">
            <div
                :class="'choose-item'+item.check"
                v-for="(item,index) in industries"
                :key="index"
                @click="handleCheckIndustries(item,index)"
            >{{item.name}}
            </div>
          </cube-scroll>
        </div>
      </div>
    </w-popup>
    <!-- 职位类型 -->
    <w-popup :state="moreState" @handleClose="handleCancelProfession">
       <!-- @touchmove.prevent -->
      <div slot="content" class="professionsTree">
        <div class="top-btn">
          <div class="cancel-btn" @click="handleCancelProfession">取消</div>
          <div class="confirm-btn" @click="handleCancelProfession">确定</div>
        </div>
        <div class="checkTags">
          <div class="tag" v-for="(item,index) in professionsConfirmData" :key="index">
            <span class="text">{{item.title}}</span>
            <span class="iconfont iconshanchu1" @click="handleCheckProfessions(item)"></span>
          </div>
          <div class="already-placeholder" v-if="!professionsConfirmData.length">最多选择3项</div>
        </div>
        

        <div class="tagContent">
          <div class="level1">
            <div class="item" :class="[professionsOptions.level1Index === index?'active':'']" v-for="(item,index) in professionsTree" :key="index" @click="professionsOptions.level1Index = index">
              {{item.label}}
            </div>
          </div>
          <template v-for="(item,index) in professionsTree">
            <div class="levels" v-if="professionsOptions.level1Index === index" :key="index">
              <div class="list">
                <div class="item" :class="[item.checked?'active':'']" @click="handleCheckProfessions({level1Index: index, listItem:item, type:'level1'})">{{item.title}}</div>
              </div>

              <template v-for="(sitem, sindex) in item.list">
                <div :key="sindex">
                  <div class="level2"><span>{{sitem.title}}</span></div>
                  <div class="list">
                    <!-- level2 -->
                    <!-- :class="[sitem.checked?'active':'',item.checked?'disabled':'']" -->
                    <div class="item"
                      :class="[sitem.checked?'active':'']"
                      @click="handleCheckProfessions({level1Index: index, level2Index: sindex, listItem:sitem, type:'level2'})"
                    >
                      <span>{{sitem.title}}</span>
                    </div>
                    <!-- level3 -->
                    <!-- :class="[ssitem.checked ?'active':'',item.checked || sitem.checked?'disabled':'']" -->
                    <div class="item"
                      :class="[ssitem.checked ?'active':'']"
                      v-for="(ssitem, ssindex) in sitem.list" :key="ssindex"
                      @click="handleCheckProfessions({level1Index: index, level2Index: sindex, level3Index: ssindex, listItem:ssitem, type:'level3'})"
                    >
                      <span>{{ssitem.title}}</span>
                    </div>

                  </div>
                </div>
              </template>
              <div class="feedback">
                <p>没有找到我的意向职位</p>
                <span @click="feedbackVisibile = true">立即反馈</span>
              </div>
            </div>
          </template>
        </div>
      </div>
    </w-popup>
    <!--  城市  -->
    <w-popup :state="cityState" @handleClose="handleCancelCity">
      <div slot="content" class="content content-city" @touchmove.prevent>
        <div class="top-btn">
          <div class="cancel-btn" @click="handleCancelCity">取消</div>
          <div class="confirm-btn" @click="handleConfirmCity">确定</div>
        </div>
        <!-- <div class="already-choose-city">
          <span
              class="choose-item active del"
              v-for="(item,index) in chooseCityList"
              :key="item.id"
              @click="handleDelCity(item,index)"
          >
            {{item.city_name}}
            <span class="iconfont iconx del"></span>
          </span>
          <div class="already-placeholder" v-if="!chooseCityList.length">最多选择3项</div>
        </div> -->
        <div class="checkTags">
          <div class="tag" v-for="(item,index) in chooseCityList" :key="index">
            <span class="text">{{item.city_name}}</span>
            <span class="iconfont iconshanchu1" @click="handleDelCity(item,index)"></span>
          </div>
          <div class="already-placeholder" v-if="!chooseCityList.length">最多选择3项</div>
        </div>

        <div class="city-dialog flex">
          <div class="letter-wrapper" :class="chooseCityList.length?'active':''">
            <cube-scroll :data="letterAry" ref="letterScroll">
              <div class="letter">
                <div
                    class="letter-code"
                    :class="{'letter-active': currentLetterIndex === index}"
                    v-for="(letter, index) in letterAry"
                    :key="index"
                    @click="changeKey(index)"
                >{{letter}}
                </div>
              </div>
            </cube-scroll>
          </div>
          <div class="city" :class="chooseCityList.length?'active':''">
            <cube-scroll :data="[currentLetterIndex]" ref="cityScroll">
              <div class="city-list">
                <span
                    class="city-name flex-center"
                    :class="{'city-active': city.checked}"
                    @click="selectCity(city,index)"
                    v-for="(city,index) in cityAry[currentLetterIndex].part_cities"
                    :key="city.id"
                >{{city.city_name}}</span>
              </div>
            </cube-scroll>
          </div>
        </div>
      </div>
    </w-popup>
    <feedback :feedbackVisibile = feedbackVisibile  @closeFeed="feedbackVisibile = false"/>
  </div>
</template>

<script>
  import WNavbar from "@/components/global/w-navbar";
  import intention from "@/api/api-list/intention";
  import WPopup from "@/components/global/w-popup";
  import salaryData from "@/assets/json/salary.json";
  import {componentsMixin} from "@/assets/js/mixin/components";
  import citiesData from "@/assets/json/global.json";
  import WLoading from "@/components/global/w-loading";
  import user from "@/api/api-list/user";
  import {envMixin, eventMixin} from "@/assets/js/mixin/global";
  import {userMixin} from '@/assets/js/mixin/user'
  import staticApi from "@/api/api-list/static-api";
  import {mapActions, mapState, mapMutations} from "vuex"
  import { onlineMixin } from '../../../assets/js/mixin/cv'
  import feedback from "../components/feedback.vue"

  export default {
    name: "intentions",
    mixins: [componentsMixin, envMixin, userMixin, eventMixin, onlineMixin],
    data() {
      return {
        feedbackVisibile:false,//求职意向反馈弹窗
        expect_status: "",//职业人的当前状态
        expect_work_type: [],//学生要看找的内容
        industries: [],//行业列表
        expect_min_salary: null,//最低期待薪资
        expect_max_salary: null,//最高期待薪资
        industriesState: false,//是否显示行业弹窗
        cascadeData: salaryData.salary,//期望薪资
        selectedIndex: [10, 0],//默认选中的薪资范围 11k-12k
        cityState: false,//显示城市弹窗
        currentLetterIndex: 0,//选中的拼音下标
        letterAry: [],//拼音数组
        cityAry: [],//城市数组
        chooseCityList: [],//已选择城市
        industriesConfirmData: [],//已选择行业集合
        loadingShow: true,//加载中
        is_student: false,//是否为学生
        jobs: 0,

        moreState: false,//是否显示职位类型弹窗
        professions: [],//职位类型列表
        professionsConfirmData: [],//已选择职位集合
        professionsOptions:{
          level1Index:0,
        },
        professionsTree:[], //职位类型数据集合
      };
    },
    computed: {
      ...mapState('cv', [ 'onlineCvData' ]),
      ...mapState('user', ['userIntention', 'isUpdate', 'userData', 'isNeedResume', 'isOnlineCv'])
    },
    mounted() {
      if (this.$route.query.jobs) {
        this.jobs = 1;
      }
    },
    watch: {},
    components: {
      WNavbar,
      WPopup,
      WLoading,
      feedback
    },
    async created() {
      if (!this.userData.intention) {
        this.setIsUpdate(false)
        // await this.$router.push("/template_matches/new")
      }
      //初始化城市
      this.cityAry = citiesData.cities.cities;
      this.letterAry = citiesData.cities.cities.map(city => city.group_name);
      // user
      await this.getUserData()
      //初始化数据
      await this.getData();

      this.is_student = this.userData.is_student;
    },
    methods: {
      ...mapActions('user', ['getUserIntention']),
      ...mapMutations('user', ['setIsUpdate', 'setIsOnlineCv']),
      //返回
      leftBtnClick() {
        if (this.isUpdate) {
          this.$router.replace("/jobs/recommend");
        } else {
          this.$router.back();
        }

      },

      // 初始化数据
      async getData() {
        try {
          let [industries, professions, intentions] = await Promise.all([staticApi.getIndustriesList(), staticApi.getProfessionsList(), intention.getIntentionNew()])
          let {industry_ids = [], profession_ids = [], expect_min_salary = null, expect_max_salary = null, city_ids = [], expect_status = "", expect_work_type = []} = intentions.data
          this.expect_status = expect_status
          this.expect_work_type = expect_work_type
          //初始化期望行业列表
          this.industries = industries.data.map(item => {
            item.name = item.cn
            return item
          });
          // this.industries.unshift({name: "不限", id: 0, check: '', cn: "不限"})
          this.industries.forEach(item => {
            if (industry_ids && industry_ids.includes(item.id)) {
              item.check = " active"
              this.industriesConfirmData.push(item)
            } else {
              item.check = ""
            }
            item.name = item.cn
          });

          //初始化职位类型列表
          // this.professions = professions.data.map(item => {
          //   item.value = item.results
          //   item.id = item.results[0]
          //   return item
          // });
          // this.professions.unshift({name: "不限", id: 0, check: '', results: [0]})
          // this.professions.forEach(item => {
          //   if (profession_ids && profession_ids.includes(item.id)) {
          //     item.check = " active"
          //     this.professionsConfirmData.push(item)
          //   } else {
          //     item.check = ""
          //   }
          // });
          //初始化薪资
          this.expect_min_salary = expect_min_salary;
          this.expect_max_salary = expect_max_salary;
          this.selectedIndex = [expect_min_salary ? (Number(expect_min_salary) - 1) : 10, expect_max_salary ? (Number(expect_max_salary) - Number(expect_min_salary) - 1) : 0];
          //初始化城市
          this.cityAry.forEach((item, index) => {
            item.part_cities.forEach(row => {
              if (city_ids && city_ids.includes(row.id)) {
                if (index != 0) {
                  this.chooseCityList.push(row)
                }
                row.checked = true
              }
            })
          })
          if (city_ids && city_ids.includes(0)) {
            this.chooseCityList.push({
              "id": 0,
              "adcode": "0",
              "city_name": "全国",
              checked: true
            })
            this.cityAry[0].part_cities[0].checked = true
          }

          // 获取树形结构的职位类型
          this.getProfessionsTree(profession_ids);
        } catch (e) {
          console.log(e)
        } finally {
          this.loadingShow = false;
        }
      },

      // 选择期望薪资
      handleChooseSalary() {
        this.cascadePicker = this.$createCascadePicker({
          title: "",
          data: this.cascadeData,
          selectedIndex: this.selectedIndex,
          onSelect: this.selectHandle,
          onCancel: this.cancelHandle
        });
        this.cascadePicker.show();
      },

      //选择完薪资之后的操作
      selectHandle(index) {
        this.expect_min_salary = index[0];
        this.expect_max_salary = index[1];
        this.selectedIndex[0] = index[0] - 1;
        this.selectedIndex[1] = index[1] - index[0] - 1;
      },

      //选择职业事件
      handleCheckProfessions({level1Index, level2Index, level3Index, listItem, type,}) {
        if(type==='level1'){
          //查找当前是否已经选中
          let checkIndex = this.professionsConfirmData.findIndex(item=> item.profession_id === listItem.profession_id);
          //查找当前大分类中是否有已经选中的
          let hasCurrentLevel = this.professionsConfirmData.findIndex(item=> item.level1Index === level1Index);
          if(checkIndex>-1){
            //反选
            this.professionsConfirmData.splice(checkIndex,1);
            this.professionsTree[level1Index].checked = false;
          }else if(this.professionsConfirmData.length === 3 && hasCurrentLevel===-1){
            this.showToast("最多选择三个")
            return
          }else{
            this.professionsTree[level1Index].checked = true;
            // 向下清除选中状态(2/3级)
            this.professionsTree[level1Index].list.forEach((sitem,sindex)=>{
              let levelIndex = this.professionsConfirmData.findIndex(item=> item.profession_id === sitem.profession_id);
              if(levelIndex>-1){
                this.professionsConfirmData.splice(levelIndex,1);
              }
              sitem.checked = false;
              sitem.list.forEach(ssitem=>{
                let levelIndex = this.professionsConfirmData.findIndex(item=> item.profession_id === ssitem.profession_id);
                if(levelIndex>-1){
                  this.professionsConfirmData.splice(levelIndex,1);
                }
                ssitem.checked = false;
              })
            })
            //添加
            this.professionsConfirmData.push({
              title: listItem.title,
              profession_id: listItem.profession_id,
              listItem,
              type,
              level1Index
            })
          }
        }else if(type === 'level2'){
          // 查找当前一级分类是否选中
          // if(this.professionsTree[level1Index].checked){
          //   return
          // }
          //查找当前是否已经选中
          let checkIndex = this.professionsConfirmData.findIndex(item=> item.profession_id === listItem.profession_id);
          //查找当前大分类/小模块中是否有已经选中的
          let hasCurrentLevel = this.professionsConfirmData.findIndex(item=> item.level1Index === level1Index && item.level2Index === level2Index);

          if(checkIndex>-1){
            //反选
            this.professionsConfirmData.splice(checkIndex,1);
            this.professionsTree[level1Index].list[level2Index].checked = false;
          }else if(this.professionsConfirmData.length === 3 && hasCurrentLevel===-1){
            this.showToast("最多选择三个")
            return
          }else{
            this.professionsTree[level1Index].list[level2Index].checked = true;
            // 向下清除选中状态（3级）
            this.professionsTree[level1Index].list[level2Index].list.forEach((sitem,sindex)=>{
              let levelIndex = this.professionsConfirmData.findIndex(item=> item.profession_id === sitem.profession_id);
              sitem.checked = false;
              if(levelIndex>-1){
                this.professionsConfirmData.splice(levelIndex,1);
              }
            })
            // 向上清除选中状态 (1级)
            let topItem = this.professionsTree[level1Index]
            let levelIndex = this.professionsConfirmData.findIndex(item=> item.profession_id === topItem.profession_id);
            topItem.checked = false;
            if(levelIndex>-1){
              this.professionsConfirmData.splice(levelIndex,1);
            }
            //添加
            this.professionsConfirmData.push({
              title: listItem.title,
              profession_id: listItem.profession_id,
              listItem,
              type,
              level1Index,
              level2Index,
            })
          }
        }else if(type === 'level3') {
          // if(this.professionsTree[level1Index].checked || this.professionsTree[level1Index].list[level2Index].checked){
          //   return
          // }
           // 向上清除选中状态 (1级)
          let topItem = this.professionsTree[level1Index]
          let levelIndex = this.professionsConfirmData.findIndex(item=> item.profession_id === topItem.profession_id);
          topItem.checked = false;
          if(levelIndex>-1){
            this.professionsConfirmData.splice(levelIndex,1);
          }
          // 向上清除选中状态 （2级）
          let level2Item = this.professionsTree[level1Index].list[level2Index]
          let targetLevel2Index = this.professionsConfirmData.findIndex(item=> item.profession_id === level2Item.profession_id);
          if(targetLevel2Index>-1){
            this.professionsConfirmData.splice(targetLevel2Index,1);
          }
          level2Item.checked = false;
          //查找当前是否已经选中
          let checkIndex = this.professionsConfirmData.findIndex(item=> item.profession_id === listItem.profession_id);
          if(checkIndex>-1){
            //反选
            this.professionsConfirmData.splice(checkIndex,1);
            this.professionsTree[level1Index].list[level2Index].list[level3Index].checked = false;
          }else if(this.professionsConfirmData.length === 3){
            this.showToast("最多选择三个")
            return
          }else{
            this.professionsTree[level1Index].list[level2Index].list[level3Index].checked = true;
            //添加
            this.professionsConfirmData.push({
              title: listItem.title,
              profession_id: listItem.profession_id,
              listItem,
              type,
              level1Index,
              level2Index,
              level3Index,
            })
          }
        }
        // if (item.check) {
        //   this.professions[index].check = ""
        //   this.professionsConfirmData.forEach((key, i) => {
        //     if (item.id == key.id) {
        //       this.professionsConfirmData.splice(i, 1)
        //     }
        //   })
        // } else {
        //   if (item.name == "不限") {
        //     this.professionsConfirmData = [{name: "不限", id: 0, check: "", results: [0]}]
        //     this.professions.forEach((row, i) => {
        //       if (i == 0) {
        //         row.check = " active"
        //       } else {
        //         row.check = ""
        //       }
        //     })
        //   } else {
        //     if (this.professionsConfirmData.length == 3) {
        //       this.showToast("最多选择三个")
        //       return
        //     }
        //     this.professions[index].check = " active"
        //     this.professions[0].check = ""
        //     this.professionsConfirmData.push(item)
        //     this.professionsConfirmData.forEach((row, i) => {
        //       if (row.name == '不限') {
        //         this.professionsConfirmData.splice(i, 1)
        //       }
        //     })
        //   }
        // }
      },

      //确认选择职业后
      handleConfirmProfession() {
        this.moreState = false;
        if (this.professionsConfirmData.length == 0) {
          this.professionsConfirmData.push({
            name: "不限",
            id: 0,
            check: " active",
            results: [0]
          });
        }
      },

      // 打开选择行业弹窗
      handleChooseIndustries() {
        this.industriesState = true;
      },

      //选择行业事件
      handleCheckIndustries(item, index) {
        if (item.check) {
          this.industries[index].check = ""
          this.industriesConfirmData.forEach((key, i) => {
            if (item.id == key.id) {
              this.industriesConfirmData.splice(i, 1)
            }
          })
        } else {
          if (this.industriesConfirmData.length == 3) {
            this.showToast("最多选择三个")
            return
          }
          this.industries[index].check = " active"
          this.industriesConfirmData.push(item)
          this.industriesConfirmData.forEach((row, i) => {
            if (row.name == '不限') {
              this.industriesConfirmData.splice(i, 1)
            }
          })

        }
      },

      //点击确认按钮进行判断如果没有选择默认为不限
      handleConfirmIndustries() {
        this.industriesState = false;
        if (this.industriesConfirmData.length == 0) {
          this.industriesConfirmData.push({
            name: "不限",
            id: 0,
            check: " active"
          });
        }
      },

      //点击取消或者遮罩层关闭行业弹窗
      handleCancelIndustries() {
        this.industriesState = false;
      },

      //关闭职业遮罩层
      handleCancelProfession() {
        this.moreState = false;
      },

      //关闭城市选择遮罩层
      handleCancelCity() {
        this.cityState = false;
      },

      //确定城市选择
      handleConfirmCity() {
        this.cityState = false;
        if (this.chooseCityList.length == 0) {
          this.chooseCityList.push({
            id: 0,
            city_name: "全国",
            checked: " active"
          });
        }
      },

      //切换拼音
      changeKey(index) {
        this.currentLetterIndex = index;
      },

      //选择意向城市
      handleChooseCity() {
        this.cityState = true;
      },

      //删除选中城市
      handleDelCity(item, index) {
        let cityAry = this.cityAry;
        cityAry.map(j => {
          j.part_cities.map(i => {
            if (item.city_name == i.city_name) {
              i["checked"] = "";
            }
          });
        });
        this.cityAry = cityAry;
        this.chooseCityList.splice(index, 1);
        this.$forceUpdate();
      },

      //选择城市事件
      selectCity(city, index) {
        // let cityAry = this.cityAry;

        if (city.checked) {
          this.cityAry[this.currentLetterIndex].part_cities[index][
            "checked"
            ] = false;
          this.chooseCityList.map((item, index) => {
            if (item.city_name == city.city_name) {
              this.chooseCityList.splice(index, 1);
            }
          });
        } else if (!city.checked) {
          if (this.chooseCityList.length == 3 && city.city_name != "全国") {
            this.showToast("最多选择三个");
            return;
          } else if (
            this.chooseCityList.length == 3 &&
            city.city_name == "全国"
          ) {
            this.chooseCityList = [];
            this.chooseCityList.push(city);
          }
          if (city.city_name == "全国") {
            this.cityAry.map(item => {
              item.part_cities.map(i => {
                if (i.city_name == "全国") {
                  i.checked = true;
                } else {
                  i.checked = false;
                }
              });
            });
            this.chooseCityList = [];
            this.chooseCityList.push(city);
          } else {
            if (this.chooseCityList.length) {
              this.chooseCityList.map((item, index) => {
                if (item.city_name == "全国") {
                  this.chooseCityList.splice(index, 1);
                }
              });
            }
            this.cityAry.map(item => {
              item.part_cities.map((i, index) => {
                if (i.city_name == "全国") {
                  i.checked = false;
                }
              });
            });

            this.chooseCityList.push(city);
          }
          // this.cityAry[this.currentLetterIndex].part_cities[index][
          //   "checked"
          //   ] = true;
          this.cityAry.forEach((item, i) => {
            item.part_cities.forEach((city_item, j) => {
              if (city_item.city_name == city.city_name) {
                city_item.checked = true
              }
            })
          })
        }
        this.$forceUpdate();
      },

      // 下一步
      async saveEditInfo() {
        // if (this.professionsConfirmData.length == 0) {
        //   this.showToast("请选择职位信息");
        //   return;
        // } else if (this.industriesConfirmData.length == 0) {
        //   this.showToast("请选择行业信息");
        //   return;
        // } else 
        if (this.chooseCityList.length === 0) {
          this.showToast("请选择城市信息");
          return;
        } else if (
          this.expect_min_salary == null &&
          this.expect_max_salary == null &&
          !this.is_student
        ) {
          this.showToast("请选择薪资范围");
          return;
        }
        let obj = {
          expect_min_salary: this.expect_min_salary || "",
          expect_max_salary: this.expect_max_salary || "",
        };

        obj.profession_full_ids = this.professionsConfirmData
          .map(item => {
            return item.profession_id;
          }).flat(Infinity)

        obj.industry_ids = this.industriesConfirmData
          .map(item => {
            return item.id;
          })

        obj.city_ids = this.chooseCityList
          .map((item, index) => {
            return item.id;
          })
        let res = await intention.updateIntentions(obj)
        if (res.code === 1000) {
          if (!this.isUpdate) {
            this.setIsUpdate(true)
          }
          this.getUserIntention()
          if (this.jobs) {
            if (this.isWxMini) {
              wx.miniProgram.navigateBack();
            } else {
              this.$router.replace("/jobs/recommend")
            }
          } else if (this.isNeedResume) {
          	if (this.draftCvList && this.draftCvList.length === 1) {
          		this.nextStep()
            } else {
          		this.$router.push('/cvs/online/list')
            }
            // this.$router.replace("/jobs/recommend")
          } else if (this.isOnlineCv) {
            this.setIsOnlineCv(false)
            this.$router.replace(`/cvs/online/${this.onlineCvData.resume.token}/preview`)
          } else {
          	this.$router.replace('/jobs/recommend')
          }
        }
      },

      //进行状态更新
      handleClickUpdate() {
        if (!this.isUpdate) {
          this.setIsUpdate(true)
        }
        this.$router.push('/template_matches/new')
      },
      //获取树形结构的职位类型
      getProfessionsTree(profession_ids){
        let professionsConfirmData = [];
        staticApi.getProfessionsTree().then(res=>{

          if(res.code === 1000){
            res.data.forEach((item,index)=>{
              item.title = `全部${item.title}`
              //检测是否选中
              if(profession_ids.includes(item.profession_id)){
                professionsConfirmData.push({
                  title: item.title,
                  profession_id: item.profession_id,
                  listItem: item,
                  type: 'level1',
                  level1Index: index,
                  level2Index: '',
                  level3Index: '',
                })
                item.checked = true;
              }else{
                item.checked = false;
              }
              // 去除 其他 开头的职位
              item.list = item.list.filter((filterItem, filterIndex) => !filterItem.title.startsWith('其他'))

              // level2
              item.list.forEach((sitem,sindex)=>{
                sitem.title = `全部${sitem.title}`
                //检测是否选中
                if(profession_ids.includes(sitem.profession_id)){
                  professionsConfirmData.push({
                    title: sitem.title,
                    profession_id: sitem.profession_id,
                    listItem: sitem,
                    type: 'level2',
                    level1Index: index,
                    level2Index: sindex,
                    level3Index: '',
                  })
                  sitem.checked = true;
                }else{
                  sitem.checked = false;
                }
                
                // level3
                sitem.list.forEach((ssitem, ssindex)=>{
                  //检测是否选中
                  if(profession_ids.includes(ssitem.profession_id)){
                    professionsConfirmData.push({
                      title: ssitem.title,
                      profession_id: ssitem.profession_id,
                      listItem: ssitem,
                      type: 'level3',
                      level1Index: index,
                      level2Index: sindex,
                      level3Index: ssindex,
                    })
                    ssitem.checked = true;
                  }else{
                    ssitem.checked = false;
                  }
                })

              })

            })
            this.professionsTree = res.data
            this.professionsConfirmData = professionsConfirmData;
          }
        })
      },
    }
  };
</script>

<style lang="scss" scoped>
  @import './index.scss';
</style>
